module.exports = __webpack_public_path__ + "img/1.001d3b91.svg";